/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-25 16:36:18
 */
import React from "react";
import lazyLoad from "@/routers/utils/lazyLoad";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
import AccountSetting from "@/pages/Setting/AccountSetting";
import Referrals from "@/pages/Setting/Referrals";
// 表单 Form 模块
const AccountSettingModal: Array<RouteObject> = [
	{
		element: <LayoutIndex />,
		meta: {
			title: "Setting",
			path: "/account",
			icon: null,
			hideInMenu: true
		},
		children: [
			{
				path: "/account/setting",
				element: <AccountSetting />,
				meta: {
					requiresAuth: true,
					title: "Account Setting",
					key: "setting",
					hideInMenu: true
				}
			},
			{
				path: "/account/referrals",
				element: <Referrals />,
				meta: {
					requiresAuth: true,
					title: "Referrals",
					key: "referral"
				}
			}
		]
	}
];

export default AccountSettingModal;
